/**
 * Учитывая interval рекламы, index карточки и массив рекламных блоков дает выход вида:
 * f(index) = 0,
 * f(index + interval) = 1,
 * f(index + 2 * interval) = 2,
 * ...,
 * f(index + adIds.length * interval) = adIds.length - 1,
 * f(index + (adIds.length + 1) * interval) = 0
 * И по этому индексу достает рекламный id
 */
export const getAdId = (adIds: string[], postIndex: number, interval: number) =>
    adIds[Math.abs((postIndex + 1) / interval - interval) % adIds.length];
